/**
 * Datos de la empresa que se muestran en la web.
 *
 * OJO: los valores marcados con "PENDIENTE" son marcadores de posicion.
 * Hay que reemplazarlos por los datos reales de Aceros Lima antes de publicar.
 */
export const EMPRESA = {
  nombre: "Grupo Aceros Lima",
  // Del logotipo oficial: la empresa se presenta por sus tres procesos.
  servicios: "Corte · Plegado · Rolado",
  legal: "Grupo Aceros Lima S.A.C.",
  ruc: "PENDIENTE — RUC",
  // PENDIENTE: eslogan propuesto, falta validarlo con el cliente.
  eslogan: "Cortamos, plegamos y rolamos el acero de tu proyecto",
  direccion: "PENDIENTE — direccion de planta / tienda",
  ciudad: "Arequipa, Peru",
  telefono: "PENDIENTE — telefono fijo",
  whatsapp: import.meta.env.VITE_WHATSAPP || "51999999999",
  email: import.meta.env.VITE_EMAIL_VENTAS || "ventas@acerolima.pe",
  horario: "Lun a Vie 8:00 - 18:00 · Sab 8:00 - 13:00",
  redes: {
    facebook: "",
    instagram: "",
    linkedin: "",
  },
};

/**
 * Maquinaria de planta. Las fotos las entrego el cliente y viven en `image/`;
 * `npm run imagenes` genera las versiones publicadas en `public/maquinas/`.
 *
 * PENDIENTE: marca, modelo y capacidades (espesor y largo maximo) de cada
 * maquina. No se declaran aqui porque no fueron indicadas.
 */
export const MAQUINAS = [
  {
    id: "laser",
    nombre: "Cortadora laser CNC",
    descripcion:
      "Corte de plancha por control numerico a partir del archivo del cliente, con mesa de listones y aspiracion.",
  },
  {
    id: "cortadora",
    nombre: "Cortadora de plancha",
    descripcion:
      "Corte recto de plancha a la medida solicitada, con tope posterior graduable.",
  },
  {
    id: "plegadora",
    nombre: "Prensa plegadora",
    descripcion:
      "Plegado de plancha con herramienta segmentada y control numerico.",
  },
  {
    id: "roladora",
    nombre: "Roladora de planchas",
    descripcion:
      "Tres rodillos para formar cilindros, virolas y curvados a partir de plancha plana.",
  },
];

/**
 * True si un dato de EMPRESA sigue siendo un marcador de posicion.
 * Las vistas lo usan para omitir el dato en vez de publicar "PENDIENTE — ...".
 */
export const esPendiente = (valor) =>
  typeof valor === "string" && valor.trim().toUpperCase().startsWith("PENDIENTE");

/** IGV vigente en Peru. */
export const IGV = 0.18;

/** Moneda por defecto del catalogo. */
export const MONEDA = "PEN";

/** Estados por los que pasa una cotizacion. */
export const ESTADOS_COTIZACION = {
  nueva: { label: "Nueva", tono: "warn" },
  enviada: { label: "Enviada", tono: "deep" },
  ganada: { label: "Ganada", tono: "ok" },
  perdida: { label: "Perdida", tono: "danger" },
};

/** Estados por los que pasa un pedido. */
export const ESTADOS_PEDIDO = {
  pendiente: { label: "Pendiente de pago", tono: "warn" },
  pagado: { label: "Pagado", tono: "deep" },
  preparando: { label: "En preparacion", tono: "deep" },
  despachado: { label: "Despachado", tono: "ok" },
  entregado: { label: "Entregado", tono: "ok" },
  anulado: { label: "Anulado", tono: "danger" },
};

/** Formas de entrega ofrecidas en el checkout. */
export const MODOS_ENTREGA = {
  recojo: {
    label: "Recojo en tienda",
    detalle: "Retiras en nuestro almacen sin costo de envio.",
    costo: 0,
  },
  delivery_local: {
    label: "Despacho en Arequipa",
    detalle:
      "Entrega en obra dentro de Arequipa. Costo referencial, se confirma por peso.",
    costo: 80,
  },
  delivery_nacional: {
    label: "Envio a otras ciudades",
    detalle: "Coordinamos agencia de transporte. El flete se cotiza aparte.",
    costo: null,
  },
};
